// Staging

// export const baseUrl = "https://tamashaprime.ecnstg.com/api/";

// export const baseUrl = "https://tamashaprime.com/api/";
export const baseUrl = "https://hidaya.mobi/server/hidaya/public/api/";

export const epmsBaseUrl = "https://tamashaprime.com/epms/";

// Production

// export const baseUrl =""

export const username = "tamashaprimeWEB";
export const password = "In1fsfs08ze64F1CwhgpuliqB5n";

export const coreUrl = "https://tamashaweb.com/login";

export const jazzCashUrl = "https://hidaya.mobi/jcms/link-wallet";

export const triviBaseurl = "https://trivia.mobi";

export const artworkBaseUrl = "https://landingartwork.trivia.mobi/api/";

export const gtmId = "GTM-MGJR5VRL";
